"use client";

import { ChevronRight } from "lucide-react";
import { motion } from "motion/react";
import Link from "next/link";

import { ProductImage } from "@/components/catalog/product-image";
import { useSubtleInteraction } from "@/components/ui/motion-primitives";
import type { CatalogFamilySummary } from "@/domain/catalog/catalog-product";

const MotionLink = motion.create(Link);

export interface CategoryListItemProps {
  readonly family: CatalogFamilySummary;
}

export function CategoryListItem({ family }: Readonly<CategoryListItemProps>) {
  const interaction = useSubtleInteraction();

  return (
    <MotionLink
      className="grid grid-cols-[72px_1fr_auto] items-center gap-4 rounded-xl border border-outline-variant bg-surface p-3 shadow-sm outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      href={`/categorias/${family.slug}`}
      prefetch={false}
      {...interaction}
    >
      <span className="flex h-16 items-center justify-center overflow-hidden rounded-lg bg-white p-[0px]">
        <ProductImage alt={family.name} imageUrl={family.representativeImageUrl} />
      </span>
      <span className="min-w-0">
        <span className="block text-base font-extrabold leading-5 text-primary">
          {family.name}
        </span>
        <span className="mt-1 block text-sm text-muted">
          {family.productCount} productos
        </span>
      </span>
      <ChevronRight aria-hidden="true" className="text-primary" size={21} />
    </MotionLink>
  );
}
